export default __webpack_public_path__ + "static/media/icon_laurel_wreath_star_white.5c648bd0.svg";